import React from 'react';
import { useIntl } from 'umi';
import { Select } from 'tea-component';
import NumberInput from '@/pages/datalab/components/NumberInput';
import type { TDateGranularity } from '@dbl/core/date';

/**
 * 时间范围值部分类型（用于 onChange 回调）
 */
type TTimeRangeValuePartial = {
  lastCount?: string;
  dateType?: string;
  isCustomOption?: boolean;
  last_day?: string;
};

/**
 * LastInputAndSelector 组件 Props 接口
 */
interface ILastInputAndSelectorProps {
  lastCount?: string;
  granularity?: TDateGranularity;
  isSelected?: boolean;
  onChange?: (value: TTimeRangeValuePartial) => void;
}

/**
 * LastInputAndSelector 组件
 * 用于自定义时间范围选择的输入和选择器组合
 */
/**
 * 默认时间范围常量
 */
const DEFAULT_LAST_COUNT = '2';
const DEFAULT_DATE_TYPE = 'day';

const LastInputAndSelector: React.FC<ILastInputAndSelectorProps> = (props) => {
  const { lastCount = DEFAULT_LAST_COUNT, granularity = DEFAULT_DATE_TYPE, isSelected, onChange } = props;
  const { formatMessage } = useIntl();

  /**
   * 处理容器点击事件
   * 阻止事件冒泡，避免触发父组件的选择逻辑
   * 当未选中时，自动切换到自定义选项并设置默认值
   */
  const handleClick = (event: React.MouseEvent<HTMLDivElement>): void => {
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();

    if (!isSelected) {
      onChange?.({
        isCustomOption: true,
        lastCount: DEFAULT_LAST_COUNT,
        dateType: DEFAULT_DATE_TYPE,
        last_day: '-1',
      });
    }
  };

  const handleNumberChange = (value: string): void => {
    onChange?.({
      lastCount: value,
      isCustomOption: true,
      dateType: granularity,
      last_day: '-1',
    });
  };

  const handleSelectChange = (value: string): void => {
    
    onChange?.({
      lastCount,
      dateType: value,
      isCustomOption: true,
      last_day: '-1',
    });
  };

  return (
    <div
      className="dbl-last-input-and-selector"
      onClick={handleClick}
    >
      <span>{formatMessage({ id: 'dbl_time_last_text' })}</span>
      <div
        className={'dbl-last-form'}
        onClick={(event) => { event.stopPropagation() }}
      >
        <NumberInput
          type="number"
          className="dbl-last-input"
          value={isSelected ? lastCount : DEFAULT_LAST_COUNT}
          onChange={handleNumberChange}
          allowNegative={false}
          allowDecimal={false}
          min={1}
        />
        <Select
          className="dbl-last-selector"
          appearance="button"
          options={[
            { text: formatMessage({ id: 'dbl_date_day_upper' }), value: 'day' },
            { text: formatMessage({ id: 'dbl_date_week_upper' }), value: 'week' },
            { text: formatMessage({ id: 'dbl_date_month_upper' }), value: 'month' },
          ]}
          value={granularity}
          onChange={handleSelectChange}
        />
      </div>
    </div>
  );
  
};

export default LastInputAndSelector;
